const init = () => {

    if (!window.analytics) {
        return
    }

    // Scroll wrapper
    const wrapper = document.querySelector('[data-scroll-wrapper]')

    // User scroll tracking by quarters (25%, 50%, 75%, 95%, 100%)
    const scrollTrackBreakpoints = [
        {
            height: wrapper.scrollHeight * .25,
            value: 25,
            fired: false
        },
        {
            height: wrapper.scrollHeight * .5,
            value: 50,
            fired: false
        },
        {
            height: wrapper.scrollHeight * .75,
            value: 75,
            fired: false
        },
        {
            height: wrapper.scrollHeight * .95,
            value: 95,
            fired: false
        },
        {
            height: wrapper.scrollHeight,
            value: 100,
            fired: false
        },
    ]


    setInterval(() => {

        for (const [key, value] of Object.entries(scrollTrackBreakpoints)) {

            // update height value - prevents window resizing tracking issues
            const percentage = scrollTrackBreakpoints[key].value / 100
            scrollTrackBreakpoints[key].height = wrapper.scrollHeight * percentage

            if ((wrapper.scrollTop + wrapper.clientHeight) >= scrollTrackBreakpoints[key].height && !scrollTrackBreakpoints[key].fired) {

                window.analytics.track('User scrolled to:', {
                    label: scrollTrackBreakpoints[key].value,
                    category: 'Scroll Percentage Event'
                })

                scrollTrackBreakpoints[key].fired = true

            }
        }

    }, 333)

}

export default {
    init
}